import { detect } from 'detect-browser';
import { getVideoCardInfo } from '@app/api/RecordMediaLib/recordMediaHelper.js';
import { getClientID } from '@app/helpers.js';

const getGraphicCard = () => {
	const graphicCard = getVideoCardInfo();
	if (graphicCard.error == null) {
		return graphicCard.renderer;
	}

	return null;
};

const browser = detect();

const getStudioGlobalTrackingInitialState = ({ showData, accountData, userData, role }) => {
	return {
		identity: {
			clientId: getClientID(),
			userId: userData._id,
			accountId: accountData._id,
			studioOwner: showData.isAuthor,
			connectionId: null,
		},
		studio: {
			recordingStatus: 'idle',
			sessionId: null,
			recordingId: null,
			takeId: null,
			studioId: showData._id,
			recorderVersion: null,
			liveCallId: null,
			streamId: null,
			isAudioContextMediaStream: false,
			role,
			uploadProgress: {
				uploadStatus: 'idle',
				uploadedBytes: 0,
				uploadPercentage: 0,
				recordedBytes: 0,
			},
		},
		permissions: {
			microphone: false,
			camera: false,
			notifications: Notification.permission === 'granted',
		},
		system: {
			cpuCores: navigator.hardwareConcurrency,
			graphicCard: getGraphicCard(),
			platform: navigator.userAgentData.platform || navigator.platform,
			agent: navigator.userAgent,
			browserType: browser.name,
			browserVersion: browser.version,
		},
		devices: {
			constraints: null,
			activeAudioOutput: null,
			activeAudioInput: null,
			activeVideoInput: null,
			echoCancellation: false,
			noiseSuppression: false,
			audioLatency: 0,
			volumeLevel: 0,
		},
		streams: {},
	};
};

export default getStudioGlobalTrackingInitialState;
